export const notification_model = {
	type_id: null,
	user_ids: [],
	text: "",
	activity_time: "",
	notificationable_type: "tasks",
	notificationable_id: null,
	sampler_text: ''
}